import React from "react";
import { Dropdown } from "semantic-ui-react"
import "./search.css"

export const Search = ({
			tickers,
                        setSelectedTickers,
                        selectedTickers
	}) => {
	const onChangeSearchBar = (e, { value }) => {
		setSelectedTickers(value);
	};

	return (
		<Dropdown
			className="transparent"
			basic
			fluid
			multiple
			search
			selection
			closeOnChange
			value={selectedTickers}
			onChange={onChangeSearchBar}
			options={tickers}
			loading={tickers.length === 0}
			scrolling
		/>
	);
};
